module.exports = __webpack_public_path__ + "img/tableau_covid_vaccin.af45f988.png";